import React from "react";
import {TRADER_NOTIFICATIONS} from "../components/notificationScope";
import {CabinetNotificationsPage} from "./CabinetNotificationsPage";

/** Вся история уведомлений трейдера. */
export function TraderNotificationsPage(): JSX.Element {
  return <CabinetNotificationsPage scope={TRADER_NOTIFICATIONS}/>;
}
